var ks = ks || {};

// Enable "sticky" sidebar
//-----------------------------------------------------------------
ks.stickyFill = function () {
  var stickyElements = document.getElementsByClassName("sticky");

  for (var i = stickyElements.length - 1; i >= 0; i--) {
    Stickyfill.add(stickyElements[i]);
  }
};

$(document).ready(function () {
  ks.stickyFill();
});

//every function here inits after resizing window
$(window).bind("resizeEnd", function () {
  //code to do after window is resized
});
